import { jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Card } from "../Card/index.js";
import "@mui/material/Card";
const stackedStyles = {
  marginBottom: "-1px",
  "&:not(:last-child)": {
    borderBottom: "1px solid transparent"
  },
  "& + :not(:last-child), &:last-child": {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  "& + :not(:last-child), &:first-of-type": {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  "&:only-of-type": {
    borderRadius: "10px"
  }
};
const StyledCard = styled(Card)(stackedStyles);
function StackableCard({
  children,
  className,
  color,
  sx,
  variant
}) {
  return /* @__PURE__ */ jsx(StyledCard, { color, variant, className, sx, children });
}
export {
  StackableCard,
  stackedStyles
};
//# sourceMappingURL=index.js.map
